import { render, staticRenderFns } from "./EventDesc.vue?vue&type=template&id=4f3e1f1f&scoped=true"
import script from "./EventDesc.vue?vue&type=script&lang=js"
export * from "./EventDesc.vue?vue&type=script&lang=js"
import style0 from "./EventDesc.vue?vue&type=style&index=0&id=4f3e1f1f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3e1f1f",
  null
  
)

export default component.exports